import React, { useEffect, useState } from 'react'
import FeatherIcon from 'feather-icons-react'
import feather from 'feather-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { Form } from 'react-bootstrap'

const Icon = ({ iconName, size = '14', style }) => {
  const [iconOption, setIconOption] = useState([])
  const [iconButton, setIconButton] = useState('')

  useEffect(() => {
    let iconList = []
    let ckdIcon = [
      'lab',
      'dental',
      'social-work',
      'ckdoctor-logo',
      'bed-history',
      'vaccine',
      'admission-note',
      'vitalsign-record',
      'vitalsign-chart',
      'treatment-plan',
    ]
    const regex = new RegExp(/\b(px|em|rem)\b/, 'i')
    const fontSize = regex.test(size) ? size : size + 'px'
    ckdIcon.forEach((key) => {
      let icon = {
        value: key,
        icon: (
          <i
            className={`ckd-icon ckd-${key} m-0`}
            style={{
              fontSize: fontSize,
            }}
          ></i>
        ),
      }
      iconList.push(icon)
    })

    let featherKey = Object.keys(feather.icons)
    featherKey.forEach((key) => {
      let icon = {
        value: key,
        icon: <FeatherIcon icon={key} size={size} />,
      }
      iconList.push(icon)
    })

    library.add(fas)
    let fasArray = Object.keys(library.definitions.fas)
    fasArray.forEach((key) => {
      let icon = {
        value: key,
        icon: (
          <i
            className={`fas fa-${key}`}
            style={{
              fontSize: fontSize,
            }}
          />
        ),
      }
      iconList.push(icon)
    })
    setIconOption(iconList)
  }, [])

  useEffect(() => {
    if (iconName && iconOption) {
      let found = iconOption.find(({ value }) => value === iconName)
      if (found) {
        let { icon } = found
        setIconButton(icon)
      } else {
        setIconButton('')
      }
    } else {
      setIconButton('')
    }
  }, [iconName, iconOption])

  if (style) {
    return <div style={style}>{iconButton}</div>
  }

  return <>{iconButton}</>
}

export default Icon
